import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadAIDrivenDevelopment'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'AI駆動開発 人材不足 開発コスト削減 DX モダナイゼーション AI活用'}
        image={'https://aitria.co.jp/images/img/download/ai-driven-development/ogp.png'}
        url={'https://aitria.co.jp/download/ai-driven-development/'}
        title="経営者が押さえておくべきAI駆動開発ハンドブック | 資料ダウンロード | Aitria（アイトリア）"
        description="AI駆動開発の全体像と実践ポイントを経営者視点で解説。人材不足やコスト課題を解決し、スピード・品質・持続性を高める最新の開発戦略をまとめました。"
      />
      <Template />
    </>
  )
}

export default Download
